"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronUp } from "lucide-react";

export default function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    // 스크롤 위치에 따라 버튼 표시 여부 결정
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener("scroll", toggleVisibility);

        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, [isVisible]);

    // 맨 위로 스크롤하는 함수
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            {isVisible && (
                <Button
                    className="fixed bottom-4 right-4 shadow-lg hover:shadow-xl transition-all duration-300 bg-brand/40 rounded-full w-12 h-12 flex flex-col items-center justify-center p-0"
                    onClick={scrollToTop}
                    variant="brand"
                    aria-label="맨 위로 스크롤"
                >
                    <ChevronUp className="h-4 w-4" />
                </Button>
            )}
        </>
    );
}
